// extracted by mini-css-extract-plugin
export var subtitle = "_dd-2";
export var title = "_dd-0";
export var titleNoWrap = "_dd-1";